import { roundMoney } from '../money';
import type { OrderChargeDraft } from '../../types/sales.types';

export const DEFAULT_CHARGE_CATEGORY_CODE = 'OTROS_CARGOS';

export const calculateOrderChargesTotal = (
  charges: Array<Pick<OrderChargeDraft, 'amount'>>,
): number => {
  return roundMoney(
    charges.reduce((sum, charge) => {
      const amount = Number(charge.amount);
      return sum + (Number.isFinite(amount) ? amount : 0);
    }, 0),
  );
};

export const createEmptyOrderChargeDraft = (
  categoryCode: string = DEFAULT_CHARGE_CATEGORY_CODE,
): OrderChargeDraft => ({
  id: crypto.randomUUID(),
  categoryCode,
  amount: 0,
  description: '',
});

export const getDefaultChargeCategoryCode = (
  categories: Array<{ code: string; isDefault: boolean }>,
): string => {
  return (
    categories.find((category) => category.isDefault)?.code ??
    categories[0]?.code ??
    DEFAULT_CHARGE_CATEGORY_CODE
  );
};
